export default function Input(props) {
  return (
    <input type={props.type} placeholder={props.placeholder} value={props.value} onChange={(event)=>{
      props.onchange(event.target.value)
    }} className={`text-[11px] md:text-[14px] ${props.classes}`}/>
  );
}
